module.exports = __webpack_public_path__ + "img/download-remains.1842e89.svg";